import { makeStyles } from '@material-ui/core/styles';

const paymentStyles = makeStyles((Theme) => ({
  cardHeaderCheckoutPayment: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '20px',
    marginBottom: '20px',

    '& h1': {
      [Theme.breakpoints.down('sm')]: {
        fontSize: Theme.typography.pxToRem(24),
        lineHeight: Theme.typography.pxToRem(29),
      },
    },
  },
  cardContainerCheckoutPayment: {
    margin: '30px 0 10px 0',
    padding: '0',
    '& .MuiFormGroup-root': {
      flexDirection: 'column',
    },
    [Theme.breakpoints.down('sm')]: {
      margin: '10px 0 0 0',
      padding: '0',
    },
    [Theme.breakpoints.up('md')]: {
      padding: '0',
      '& .MuiFormGroup-root': {
        flexDirection: 'row',
        justifyContent: 'space-between',
      },
    },
  },
}));

export default paymentStyles;
